export default {
    "home.title": "We are a creative\ndigital studio"
}


// WEBPACK FOOTER //
// ./src/lang/en/index.js